import { Routes as DomRoutes, Route } from "react-router-dom";

import { useCommonStore, useUserStore } from "@stores/index";
import {
  LoginForm,
  RegisterForm,
  PasswordForgotForm,
  PasswordResetForm,
  AcceptInvitationForm,
  FaqPage,
  ProfilePage,
  ChangeNameForm,
  ChangePhoneForm,
  MyBusinessesPage,
  ChangePasswordForm,
  AssetsTable,
  LeaveForm,
  RedStatementPage,
  TransactionsTable,
  TransactionForm,
  SubmissionsTable,
  SubmissionDetails,
  MileageTable,
  LogoutPage,
  VerifyEmailPage,
  DashboardPage,
  NotFoundPage,
  QueriesPage,
} from "@pages/index";
import { PrivateRoutes } from "@components/index";

export const Routes = () => {
  const isAuth = useCommonStore(({ isAuth }) => isAuth);
  const userId = useUserStore(({ userId }) => userId);
  const puEnabled = useUserStore(({ puEnabled }) => puEnabled);
  const disabledFeatures = useUserStore(
    ({ disabledFeatures }) => disabledFeatures,
  );

  return (
    <DomRoutes>
      <Route path="login" element={<LoginForm />} />
      <Route path="register" element={<RegisterForm />} />
      <Route path="password-forgot" element={<PasswordForgotForm />} />
      <Route path="password-reset/*" element={<PasswordResetForm />} />
      <Route path="accept-invitation/*" element={<AcceptInvitationForm />} />
      <Route path="logout" element={<LogoutPage />} />
      <Route element={<PrivateRoutes />}>
        <Route path="faq" element={<FaqPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="profile/change-name" element={<ChangeNameForm />} />
        <Route path="profile/change-phone" element={<ChangePhoneForm />} />
        <Route path="profile/my-businesses" element={<MyBusinessesPage />} />
        <Route
          path="profile/change-password"
          element={<ChangePasswordForm />}
        />
        <Route path="profile/leave" element={<LeaveForm />} />
        <Route path="profile/red-statement" element={<RedStatementPage />} />
        <Route path="transactions/create" element={<TransactionForm />} />
        <Route path="transactions/update/*" element={<TransactionForm />} />
        <Route
          path="transactions/refund/*"
          element={<TransactionForm isRefundForm />}
        />
        <Route path="transactions/details/*" element={<TransactionsTable />} />
        <Route path="transactions" element={<TransactionsTable />} />
        <Route path="submissions/details/*" element={<SubmissionDetails />} />
        <Route path="submissions" element={<SubmissionsTable />} />
        {puEnabled && !disabledFeatures.includes("Private Use") && (
          <>
            <Route
              path="privateUse/details/*"
              element={<SubmissionDetails isPrivateUse />}
            />
            <Route
              path="privateUse"
              element={
                <SubmissionsTable isPrivateUse activeTab="Private use log" />
              }
            />
          </>
        )}
        {!disabledFeatures.includes("Assets") && (
          <>
            <Route path="assets/*" element={<AssetsTable />} />
            <Route path="assets" element={<AssetsTable />} />
          </>
        )}
        {!disabledFeatures.includes("Mileage Log") && (
          <>
            <Route path="mileage/*" element={<MileageTable />} />
            <Route path="mileage" element={<MileageTable />} />
          </>
        )}
        <Route path="verify-email/*" element={<VerifyEmailPage />} />
        <Route path="queries" element={<QueriesPage />} />
        <Route path="/" element={<DashboardPage />} />
      </Route>
      {isAuth && userId && <Route path="*" element={<NotFoundPage />} />}
      {!isAuth && <Route path="*" element={<NotFoundPage />} />}
    </DomRoutes>
  );
};
